import { TokenService } from '@admin/core/services/token.service';
import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, combineLatest } from 'rxjs';
import { map, filter, tap, take } from 'rxjs/operators';
import { AuthService } from '@auth0/auth0-angular';

@Injectable()
export class AuthenticatedGuard implements CanActivate {
  constructor(
    private readonly tokenService: TokenService,
    private readonly router: Router,
    private readonly authService: AuthService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return combineLatest([this.authService.isLoading$, this.tokenService.accessTokenObservable]).pipe(
      tap(([loading, token]) => {

        // Only process when Auth0 is not loading
        if (!loading) {
          // If no token and trying to access protected route, store URL and redirect
          if (!token && state.url !== '/') {
            sessionStorage.setItem('auth_redirect_url', state.url);
            this.router.navigate(['/']);
          }
        }
      }),
      filter(([loading, token]) => !loading && !!token), // Wait for Auth0 to finish loading and token to be available
      map(() => true), // Allow navigation when token is available
      take(1), // Take first valid state
    );
  }
}
